import { listenerMiddleware } from "../../../store/middleware";
import { setLoader } from "./MapDisplaySlice.js";
import { changeMap, getMapSettings } from './MapDisplayThunks.js';
import config from "../../../constants/config.js";
import { mapSocketFactory } from "../../../utils/socketFactory.js";
import { joinRoom } from "../../ControlPanel/store/interact/interactThunks.js";

listenerMiddleware.startListening({
    actionCreator: changeMap.fulfilled,
    effect: async (action, listenerApi) => {
        listenerApi.dispatch(setLoader(true))
        listenerApi.dispatch(getMapSettings())
    }
})

listenerMiddleware.startListening({
    actionCreator: joinRoom.fulfilled,
    effect: async (action, listenerApi) => {
        // Only fetch map settings if the map has changed
        if (!action.payload.isSameMap) {
            listenerApi.dispatch(setLoader(true))
            listenerApi.dispatch(getMapSettings())
        }
    }
})

listenerMiddleware.startListening({
    actionCreator: getMapSettings.fulfilled,
    effect: async (action, listenerApi) => {
        // Initialize map socket with the new map ID if payload map id is diffrent from current
        if (!action.payload?.id !== listenerApi.getState().MapDisplay.mapConfig?.mapId) {
            mapSocketFactory.initializeSocket({
                url: config.SERVER_URL + '/tenant/' + listenerApi.getState().auth.tenant.id + '/map/' + action.payload.id,
                options: {
                    withCredentials: true,
                    query: {
                        email: listenerApi.getState().auth.localAvatar.email,
                        id: listenerApi.getState().auth.localAvatar.id,
                        tenantId: listenerApi.getState().auth.tenant.id,
                        mapId: action.payload.id
                    },
                    auth: {
                        token: listenerApi.getState().auth.token
                    }
                }
            });
        }
        listenerApi.dispatch(setLoader(false))
    }
})